// extracted by mini-css-extract-plugin
export default {"header":"PaginaPadrao_header__rmVR+","header__text":"PaginaPadrao_header__text__ytZED"};